<template>
  <div class="changePasswordMain">

    <div class="maindiv">
      <div class="formArea">
        <el-form ref="form" :model="model" label-width="120px" label-position="top">
          <el-row>
            <el-col :span="8" :offset="8">
              <el-form-item :label="$t('queryForm.companyEmail')" prop="currentpwd">
                <el-input v-model="model.EmailName" :placeholder="$t('queryForm.pleaseEnter')" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="8">
              <!-- <el-form-item :label="$t('administration.OldPassword')" prop="currentpwd">
                <el-input v-model="model.currentpwd" show-password :placeholder="$t('queryForm.pleaseEnter')" />
              </el-form-item> -->

              <el-form-item v-if="visible1" :label="$t('administration.OldPassword')">
                <el-input type="password" v-model="model.currentpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="显示密码" @click="changePass1('show')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeopen"></i>
                </el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('administration.OldPassword')">
                <el-input type="text" v-model="model.currentpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="隐藏密码" @click="changePass1('hide')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeclose"></i>
                </el-input>
              </el-form-item>




            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="{span:8,offset:8}" :span="8" :offset="8">
              <!-- <el-form-item :label="$t('administration.NewPassword')" prop="newpwd" windth="100">
                <el-input v-model="model.newpwd" show-password :placeholder="$t('queryForm.pleaseEnter')" />
              </el-form-item> -->

              <el-form-item v-if="visible2" :label="$t('administration.NewPassword')">
                <el-input type="password" v-model="model.newpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="显示密码" @click="changePass2('show')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeopen"></i>
                </el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('administration.NewPassword')">
                <el-input type="text" v-model="model.newpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="隐藏密码" @click="changePass2('hide')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeclose"></i>
                </el-input>
              </el-form-item>


            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" :offset="8">
              <!-- <el-form-item :label="$t('administration.ConfirmPassword')" prop="renewpwd">
                <el-input v-model="model.renewpwd" show-password :placeholder="$t('queryForm.pleaseEnter')" />
              </el-form-item> -->
              <el-form-item v-if="visible3" :label="$t('administration.ConfirmPassword')">
                <el-input type="password" v-model="model.renewpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="显示密码" @click="changePass3('show')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeopen"></i>
                </el-input>
              </el-form-item>
              <el-form-item v-else :label="$t('administration.ConfirmPassword')">
                <el-input type="text" v-model="model.renewpwd" :placeholder="$t('queryForm.pleaseEnter')" >
                  <i slot="suffix" title="隐藏密码" @click="changePass3('hide')" style="cursor:pointer;"
                    class="el-input__icon iconfont el-icon-ali-eyeclose"></i>
                </el-input>
              </el-form-item>

            </el-col>
          </el-row>
          <el-form-item class="line btn-box input-form-btn-list pasBtn">
            <!-- <el-button type="primary" plain @click="cancel">Cancel</el-button>
            <el-button type="primary" round @click="saveForm">Save</el-button> -->
            <cus-btn type="cancel" @click="cancel()"></cus-btn>
            <cus-btn type="save"  @click="saveForm()"></cus-btn>
          </el-form-item>
        </el-form>
      </div>
      <!-- <div class="footer-custom">
            <cus-btn type="save" @click="saveForm" />
          </div> -->

    </div>

  </div>
</template>

<script>
import { changePassword } from '../../api/changePassword'
export default {
  data() {
    return {

      model: {
        EmailName: '',
        currentpwd: '',
        newpwd: '',
        renewpwd: '',
      },
      visible1: true,
      visible2: true,
      visible3: true 
    }
  },
  mounted() {
    this.model.EmailName = this.$store.state.user.userinfo.email
  },
  methods: {

    changePass1(value) {
        this.visible1 = !(value === 'show');
      } ,   //判断渲染，true:暗文显示，false:明文显示
      changePass2(value) {
        this.visible2 = !(value === 'show');
      } ,   //判断渲染，true:暗文显示，false:明文显示
      changePass3(value) {
        this.visible3 = !(value === 'show');
      } ,

    cancel(){
      this.$router.go(-1);
    },

    saveForm() {
      let str = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,12}$/;
      if (!this.model.EmailName) {
        this.$message.error(this.$t("administration.usermailboxempty"))
        return
      } else if (!this.model.currentpwd) {
        this.$message.error(this.$t("administration.xentepassword"))
        return
      } else if (!this.model.newpwd) {
        this.$message.error(this.$t("administration.xentenewpassword"))
        return
      }else if ( !str.test(this.model.newpwd) ){
        this.$message.error(this.$t("administration.pawTesting"))
        return
      } else if (!this.model.renewpwd) {
        this.$message.error(this.$t("administration.xentenewthepassword"))
        return
      } else if (this.model.renewpwd !== this.model.newpwd) {
        this.$message.error(this.$t("administration.pwdpism"))
        return
      }

      const self = this
      const param = {
        userId: this.$store.state.user.userinfo.userId,
        passwordOld: self.model.currentpwd,
        passwordNew: self.model.newpwd
      }
      changePassword(param).then(response => {
        // debugger
        if (response.code == 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.$router.push({
            path: '/login'
          })
        }
      })
    }

  }
}
</script>

<style lang="scss">

/* .pasTitle{
  color: #666666;
  margin-bottom: 12px;
  font-size: 18px;

} */
.changePasswordMain{
  .el-form-item__label{
    padding: 0;
    color: #666666;
    //font-size: 18px;
  }
  // .pasBtn{
  //   text-align: center;
  //   .el-button{
  //     width: 168px;
  //   }
  //   .input-form-btn-list .el-button + .el-button{
  //     margin-left: 82px;
  //   }
  // }
  .el-input__suffix{
    right: 15px;
  }
}

</style>
